export const breadcrumbs = {
  breadcrumbHome: "Tuis",
  breadcrumbCasino: "Casino",
  breadcrumbLottery: "Lotery",
  breadcrumbRaffles: "Raffles",
  breadcrumbNews: "Nuus",
  breadcrumbArticle: "Artikel",
  breadcrumbSports: "Sport",
  breadcrumbGameFeed: "Speletjiesstroom",
  breadcrumbMyTickets: "My kaartjies",
  breadcrumbResults: "Uitslae",
  breadcrumbAllGames: "Alle speletjies",
  breadcrumbGames: "Speletjies",
  breadcrumbTerms: "Bepalings en voorwaardes",
  breadcrumbDeleteAccount: "Verwyder rekening",
  breadcrumbProfile: "Profiel",
  breadcrumbProvider: "Verskaffer",
  breadcrumbHorses: "Perde",
  breadcrumbMiniJuegos: "Mini-speletjies",
  breadcrumbFavorites: "Gunstelinge",
};
